import React from "react";
import { FaLinkedin, FaGithub, FaEnvelope } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="bg-black text-gray-400 px-8 md:px-20 pt-20 pb-8">
      <div className="grid md:grid-cols-4 gap-10">
        {/* Logo + Tagline */}
        <div>
          <h2 className="text-white text-2xl font-bold mb-3">Tefeena John</h2>
          <p className="text-sm leading-relaxed">
            Helping you build digital experiences where aesthetics meet
            functionality.
          </p>
          <div className="flex gap-4 mt-5 text-white text-xl">
            <a
              href="https://www.linkedin.com/in/tefeena/"
              target="_blank"
              rel="noreferrer"
              className="hover:text-[#0077b5] transition-colors duration-200"
            >
              <FaLinkedin />
            </a>
            <a
              href="https://github.com/tefeena"
              target="_blank"
              rel="noreferrer"
              className="hover:text-[#6cc644] transition-colors duration-200"
            >
              <FaGithub />
            </a>
            <a
              href="https://www.instagram.com/tefzz__?igsh=dXllY25tZ3ppZTI0"
              target="_blank"
              rel="noreferrer"
              className="hover:text-[#e1306c] transition-colors duration-200"
            >
              <FaInstagram />
            </a>
          </div>
        </div>

        {/* Navigation Links */}
        <div>
          <h3 className="text-white font-semibold mb-3">General</h3>
          <ul className="space-y-2 text-sm">
            <li>
              <a href="#hero" className="hover:text-[#55e6a5] transition">
                Home
              </a>
            </li>
            <li>
              <a href="#projects" className="hover:text-[#55e6a5] transition">
                Projects
              </a>
            </li>
            <li>
              <a href="#about" className="hover:text-[#55e6a5] transition">
                About
              </a>
            </li>
            <li>
              <a href="#contact" className="hover:text-[#55e6a5] transition">
                Contact
              </a>
            </li>
          </ul>
        </div>

        {/* Quote Section */}
        <div className="text-sm leading-relaxed">
          <h3 className="text-white font-semibold mb-3">Inspiration</h3>
          <p className="italic">
            "Like I always say, can't find a door? Make your own."
            <br />– Edward Elric, Fullmetal Alchemist
          </p>
        </div>

        {/* Contact Info */}
        <div>
          <h3 className="text-white font-semibold mb-3">Let’s Connect</h3>
          <p className="text-sm mb-3">
            Feel free to reach out for collaboration or project inquiries.
          </p>
          <a
            href="mailto:tefeenajohn@gmail.com"
            className="flex items-center gap-2 text-[#3fa9f5] hover:underline text-sm"
          >
            <FaEnvelope /> tefeenajohn@gmail.com
          </a>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="border-t border-white/10 mt-12 pt-6 text-xs text-center text-gray-500">
        © {new Date().getFullYear()} Tefeena K. John. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
